import { BaseFetch } from "../main-model"
export default class MeasurementCentralModel extends BaseFetch {
  getMeasurementCentralById = (data) =>
    this.authFetch({
      url: "measurement-central/getMeasurementCentralById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateMeasurementCentralById = (data) =>
    this.authFetch({
      url: "measurement-central/updateMeasurementCentralById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertMeasurementCentral = (data) =>
    this.authFetch({
      url: "measurement-central/insertMeasurementCentral",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteMeasurementCentralById = (data) =>
    this.authFetch({
      url: "measurement-central/deleteMeasurementCentralById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
